<template lang="pug">
  .redirecionar-app
    h1.redirecionar-app__mensagem Aguarde, estamos redirecionando você para o aplicativo...
</template>

<script>
/**
 * @name RedirecionarApp
 * @description Componente para redirecionar o usuário para o aplicativo ou para a loja de aplicativos
 * através do deeplink ou do link da loja, caso o usuário não tenha o aplicativo instalado.
 * caso seja um desktop, redireciona para a home via sincronizador.
 */
export default {
  methods: {
    /**
     * Envia o usuário para o aplicativo através do deeplink
     */
    enviarParaAplicativo () {
      window.location = 'bateponto://'
    },

    /**
     * Envia o usuário para a loja de aplicativos, se não envia para a home
     */
    enviarParaLoja () {
      const agente = navigator.userAgent

      if (agente.match(/Android/i)) {
        window.location = 'https://play.google.com/store/apps/details?id=com.pontotel.bateponto'
      } else if (agente.match(/iPhone|iPad|iPod/i)) {
        window.location = 'https://apps.apple.com/app/id1531898009'
      } else {
        this.$router.push({name: 'sincronizador'})
      }
    }
  },
  mounted () {
    this.enviarParaAplicativo()

    // caso deep link não funcione, redireciona para a loja
    setTimeout(() => {
      this.enviarParaLoja()
    }, 3000)
  }

}
</script>

<style scoped>
.redirecionar-app {
  margin: auto;
  padding: 0 0.5rem;
}

.redirecionar-app__mensagem {
  text-align: center;
}

@media (max-width: 768px) {
  .redirecionar-app__mensagem {
    font-size: 1.5rem;
  }
}
</style>
